import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Drawer } from '@material-ui/core';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import Masonry from 'react-masonry-css'
import Paper from '@mui/material/Paper';
import ComFunction from "../components/ComFunction";
import { isEmpty, getWindowDimensions, CellType, setglobaldata, DeepCopy, getglobaldata, stickynote, stickymark, stickycolor, numformat, masterformat, selectformat} from '../modules/appLibrary';
import Divider from '@material-ui/core/Divider';
import noimage from '../Resources/noimage.jpg';
import { changestatus } from '../modules/formstore';
import { makeStyles } from '@material-ui/core/styles';

const styles = {
    paper: {
        backgroundColor: '#F6F5F2 !important',  // !importantが重要
    }
}
//---------------------------------------------------------------------
//  MASONRY
//---------------------------------------------------------------------
export default function MasonryForm(props) {
    const fnc = useRef();
    const ComFunc = React.forwardRef(ComFunction);
    const EntrybodyRef = useRef(null);
    const dispatch = useDispatch();

    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    const stickyopen = useSelector(state => state.search.stickyopen);
    const formstatus = useSelector(state => state.form.status);
    const masonrydata = useSelector(state => state.form.masonrydata);
    const CELLTYPE = CellType();
    const useStyles = makeStyles(styles);
    const classes = useStyles();

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
            console.log(getWindowDimensions().width);
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        restoreScrollPos();
    }, [stickyopen]);

    // スクロール位置を保存する
    function saveScrollPos() {
        setglobaldata("masonry_scrollY", EntrybodyRef.current.children[0].scrollTop);
    }
    // スクロール位置を復元する
    function restoreScrollPos() {
        try {
            const scrollY = getglobaldata("masonry_scrollY");
            if (scrollY) EntrybodyRef.current.children[0].scrollTop = scrollY;
        } catch { }
    }

    function StickySearch(e,index) {
        //検索リストOPEN
        saveScrollPos();
        let data = props.columns.find(e => e.colId === props.sticky);
        if (isEmpty(data)) return;
        props.fnc.current.searchlistopen({
            label: "付箋",
            multiple: false,
            rowmode: false,
            rowid:index,
            data: data.colinfo,
            doApply: Apply
        });
        function Apply(e) {
            fnc.current.searchlistclose();
            const newdata = DeepCopy(masonrydata);
            let item = newdata[e.rowid];
            if (props.sticky in item) {
                item[props.sticky].mark = e.value;
                item[props.sticky].color = e.color;
            } else {
                item[props.sticky] = { "mark": e.value, "color": e.color };
            }
            const param = {
                "rowdata": [item],
                "key": props.sticky,
                "type": "sticky"
            }
            fnc.current.postaxios(props.actionurl.masonry, param,
                {
                    onSuccess: function (data) {
                        fnc.current.masonrydata(newdata);
                        props.savefinally(item);
                        fnc.current.wait(false);
                        restoreScrollPos();
                   },
                    errmsg: "更新に失敗しました"
                }
            )
        }
    }
    function StickyMemo(e, index) {
        e.preventDefault();
        saveScrollPos();
        let elem = document.getElementById("masonry" + index);
        if (isEmpty(elem)) return;
        fnc.current.popupopen({
            key:index,
            defaultvalue: stickynote(masonrydata[index][props.sticky]),
            top: elem.offsetTop + 150 - EntrybodyRef.current.children[0].scrollTop,
            left: elem.offsetLeft,
            onApply: Apply
        });
        function Apply(e) {
            const newdata = DeepCopy(masonrydata);
            let item = newdata[e.key];
            if (props.sticky in item) {
                item[props.sticky].note = e.value;
            } else {
                item[props.sticky] = { "note": e.value};
            }
            const param = {
                "rowdata": [item],
                "key": props.sticky,
                "type": "sticky"
            }
            fnc.current.postaxios(props.actionurl.masonry, param,
                {
                    onSuccess: function (data) {
                        fnc.current.masonrydata(newdata);
                        props.savefinally(item);
                        fnc.current.wait(false);
                        restoreScrollPos();
                    },
                    errmsg: "更新に失敗しました"
                }
            )
        }
    }
    function EditMemo(e,index) {
        saveScrollPos();
        let elem = document.getElementById("masonry" + index);
        if (isEmpty(elem)) return;
        fnc.current.formdialogopen({ title: "memoの編集", inputname: "memo", defaultvalue: masonrydata[index][props.memo], textarea:true, onApply: Apply });
        function Apply(e) {
            const newdata = DeepCopy(masonrydata);
            let item = newdata[index];
            item[props.memo] = e;
            const param = {
                "rowdata": [item],
                "key": props.memo,
                "type": "memo"
            }
            fnc.current.postaxios(props.actionurl.masonry, param,
                {
                    onSuccess: function (data) {
                        fnc.current.formdialogclose();
                        fnc.current.masonrydata(newdata);
                        props.savefinally(item);
                        fnc.current.wait(false);
                        restoreScrollPos();
                    },
                    errmsg: "更新に失敗しました"
                }
            )
        }
    }

    function CallEntryForm(data) {
        props.setentryrow([data]);
        if (props.show(data)) {
            dispatch(changestatus("ENTRY FORM"));
        }
    }

    function imageurl(data) {
        if ("imageurl" in data) {
            if (!isEmpty(data["imageurl"])) {
                return data["imageurl"];
            }
        }
        return noimage;
    }
    function mark(data) {
        let value = "arrow_right";
        let sticky = props.sticky;
        if (sticky in data) {
            if (!isEmpty(data[sticky])) {
                value = stickymark(data[sticky]);
            }
        }
        return value;
    }
    function color(data) {
        let value = "white";
        let sticky = props.sticky;
        if (sticky in data) {
            if (!isEmpty(data[sticky])) {
                value = stickycolor(data[sticky]);
            }
        }
        return value;
    }
    function note(data) {
        let value = "";
        let sticky = props.sticky;
        if (sticky in data) {
            if (!isEmpty(data[sticky])) {
                value = stickynote(data[sticky]);
            }
        }
        return value;
    }
    function DispValue(value, coldef,data) {
        if (isEmpty(value)) return <br/>;
        if (isEmpty(coldef.colinfo)) return value;
        if (coldef.colinfo.datatype === CELLTYPE.NUM) {
            let val = numformat(Number(value), coldef.colinfo);
            return val;
        }
        if (coldef.colinfo.datatype === CELLTYPE.MASTER) {
            return masterformat(value, data, coldef);
       }
        if (coldef.colinfo.datatype === CELLTYPE.SELECT) {
            return selectformat(value, coldef.colinfo);
        }
        return value;
    }
    function Detail(p) {
        if (isEmpty(p)) return null;
        let data = p.data;
        let column = p.column;
        if (column.field === props.pkey || column.field === props.sticky) return null;

        return <div>
            <div style={{ fontSize: 8, color: '#999999' }}>
            {column.headerName}
            </div>
            <div style={{ fontSize: 10, marginLeft: 10 }}>
                {DispValue(data[column.field], column, data)}
            </div>
        </div>
    }

    const breakpointColumnsObj = {
        default: 6,
        1300:5,
        1060: 4,
        860: 3,
        660: 2
    };

    function RenderBody() {
        if (formstatus !== "MASONRY") return null;
        return <div>
            <Drawer anchor={"bottom"}
                variant="permanent"
                ref={EntrybodyRef}
                classes={{ paper: classes.paper }}
            >
                <div style={{ height: windowDimensions.height - 90, padding: 20 }} >
                    <Masonry
                        breakpointCols={breakpointColumnsObj}
                        className="my-masonry-grid"
                        columnClassName="my-masonry-grid_column">
                        {masonrydata.map((data, index) => (
                            <Paper style={{ position: 'relative', width: 200, padding: 5 }} id={ "masonry" + index}>
                                <img
                                    src={imageurl(data)}
                                    alt={imageurl(data)}
                                    loading="lazy"
                                    style={{ width: 190 }}
                                    onDoubleClick={()=>CallEntryForm(data)}
                                />
                                {props.memo === "" ? null :
                                    <div style={{ position: 'absolute', top: 0, right: 0 }}>
                                        <IconButton title = "memo編集" onClick={(e) => EditMemo(e, index)}>
                                            <Icon style={{fontSize:12}}>note_alt</Icon>
                                        </IconButton>
                                    </div>
                                }
                                {props.sticky === "" ? null :
                                    <div style={{ position: 'absolute', top: 0, left: 0 }}>
                                        <IconButton title={note(data)} onClick={(e) => StickySearch(e, index)} onContextMenu={(e) => StickyMemo(e, index)}>
                                            <Icon style={{ color: color(data) }}>{mark(data)}</Icon>
                                        </IconButton>
                                    </div>
                                }
                                <div>{data[props.pkey]}</div>
                                <Divider />
                                {props.columns.filter(e => !e.hide).map((column, index) => (
                                    <Detail data={data} column={column}/>
                                ))}
                                </Paper>
                        ))}
                    </Masonry>

                </div>
             </Drawer>
            <ComFunc ref={fnc} />
        </div>
    }
        return (
            <RenderBody />
        );
};
